import React from "react";
import { RocketLaunch } from "@mui/icons-material";
import "./styles.scss";

/**
 * Shared free trial banner for Investors and Florence.
 * @param {string} title - Main heading (e.g. "Enjoy your free trial!")
 * @param {React.ReactNode} description - Body copy
 * @param {number} remainingCount - Remaining uses (e.g. 3)
 * @param {number} maxCount - Total trial allowance (e.g. 5 or 3)
 * @param {() => void} onUpgrade - Called when "Upgrade now" is clicked
 */
function FreeTrialBanner({ title, description, remainingCount, maxCount, onUpgrade }) {
  const progressPercent = maxCount > 0 ? (remainingCount / maxCount) * 100 : 0;

  return (
    <div className="free-trial-banner">
      <div className="free-trial-banner__accent" />
      <div className="free-trial-banner__content">
        <div className="free-trial-banner__header">
          <span className="free-trial-banner__icon">
            <RocketLaunch />
          </span>
          <div className="free-trial-banner__text">
            <h2 className="free-trial-banner__title">{title}</h2>
            {description && <p className="free-trial-banner__description">{description}</p>}
          </div>
        </div>
        <div className="free-trial-banner__footer">
          {maxCount > 0 && (
            <div className="free-trial-banner__progress-wrap">
              <span className="free-trial-banner__progress-label">
                {remainingCount} of {maxCount} remaining
              </span>
              <div className="free-trial-banner__progress-track">
                <div
                  className="free-trial-banner__progress-bar"
                  style={{ width: `${progressPercent}%` }}
                />
              </div>
            </div>
          )}
          <button
            type="button"
            className="free-trial-banner__cta"
            onClick={onUpgrade}
            aria-label="Upgrade to unlock more"
          >
            Upgrade now
          </button>
        </div>
      </div>
    </div>
  );
}

export default FreeTrialBanner;
